/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  };


  // header show
  growApp.prototype.showhead = function () {
    var width = $(window).innerWidth();
    if (width < 750) {
      return false;
    }

    var $win = $(window);
    var fixedheader = $('.js-header').clone().appendTo('body');
    var fixedheaderClone = fixedheader.addClass("js-header-clone");

    var showClass = 'is-show';

    $win.on('load scroll', function () {
      var value = $(this).scrollTop();
      if (value > 680) {
        fixedheaderClone.addClass(showClass);
      } else {
        fixedheaderClone.removeClass(showClass);
      }
    });
  };



  growApp.prototype.countUp = function () {
    var width = $(window).innerWidth();
    if (width < 750) {
      return false;
    }

    var selector = '.js-countup';// 対象のDOMのセレクタ

    if (selector.length == ""){
      return false;
    }
    var $years = $(selector);
    $years.each(function () {
      var year = $(this).text();
      $(this).text(1965);
      var tempyear = 1965;
      var self = this;
      var scrollStart = function () {
        if (($(self).offset().top - 800) < $(window).scrollTop()) {
          var interval = setInterval(function () {
            if (tempyear < year) {
              tempyear++;
              $(self).text(tempyear);
            } else {
              clearInterval(interval);
              return false;
            }
          }, 50)
        } else {
          window.requestAnimationFrame(scrollStart)
        }
      };
      window.requestAnimationFrame(scrollStart)
    });
  };



  growApp.prototype.enterAnimation = function () {
    var win = $(window).innerWidth();
    var $mainContent = document.querySelector(".c-main-visual__content");
    if (win < 750) {
      $mainContent.classList.add('is-visible');
      return false;
    }
    var $mainVisual = document.querySelector(".c-main-visual");

    var $mainImage = document.querySelector(".c-main-visual__images");


    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.classList.add(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function () {

      if ($mainVisual) {
        changeClass($mainImage, "is-active", 1000).then(function () {
          changeClass($mainImage, "is-move", 800).then(function () {
            changeClass($mainContent, "is-active", 1500).then(function () {
            });
          });
        });
      }
    };
    // first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      loaderFunction();
    }
  };


  growApp.prototype.anchorVariable = function () {
    var anchorList = $('.js-variable');
    var anchorItem = anchorList.find('.js-anchor');

    if (anchorItem.length < 4){
      anchorList.find('.row').addClass('is-center');
    }
  };


  growApp.prototype.bannerPosition = function () {

    var $window = $(window);
    var $banner = $('.c-floating-button');
    var $offer = $('.l-offer');
    var $footer = $('.l-footer');
    if ( $banner.length === 0 || $offer.length === 0  || $footer.length === 0 ) {
      return false;
    }

    var h = $(document).height();
    var h_offer = $offer.height();
    var h_footer = $footer.height();
    var sup = 1500; //ここの数字で微調整
    var pos = h - ( h_offer + h_footer + sup  );

    //スマホで数字調整はこちらでどうぞ
    if ( $(window).innerWidth() > 750 ) {
    }

    //実行
    $window .on("scroll", function() {
      if ( pageYOffset > pos) {
        $banner.addClass('is-btm');
      }

      if ( pageYOffset < pos) {
        $banner.removeClass('is-btm');
      }
    });
  }





  $(function () {
    var app = new growApp();
    app.myCode();
    app.showhead();
    app.countUp();
    app.enterAnimation();
    app.anchorVariable();
    app.bannerPosition();
  });
})(jQuery);
